module.exports = '<!DOCTYPE html>\n<npdc:search-input feed="feed"></npdc:search-input>\n<npdc:search feed="feed" options="searchOptions"></npdc:search>\n';